module.exports = __webpack_public_path__ + "static/media/BonfireBBQlogo2017.5e795d3f.webp";